import { createGlobalStyle } from "styled-components";

import Roboto from "./assets/fonts/Roboto.ttf";
import OpenSans from "./assets/fonts/OpenSans-Regular.ttf";
import MontserratLight from "./assets/fonts/Montserrat-Light.ttf";
import MontserratRegular from "./assets/fonts/Montserrat-Regular.ttf";

export default createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
    }

    .slick-prev:before, .slick-next:before {
        display: none;
    }

    @font-face {
        font-family: "Roboto";
        src: url(${Roboto});
    }
    @font-face {
        font-family: "OpenSans";
        src: url(${OpenSans});
    }
    @font-face {
        font-family: "MontserratLight";
        src: url(${MontserratLight});
    }
    @font-face {
        font-family: "MontserratRegular";
        src: url(${MontserratRegular});
    }

    body {
        font-family: 'MontserratRegular';
        background: #ecf1f8;

        &::-webkit-scrollbar {
        width: 7px;
        color: gray;
        background: transparent;
        }

        &::-webkit-scrollbar-thumb {
        background: gray;
        }
    }

    :root {
        --green-main: #0a9e9e;
        --green-dark: #024848;
        --green-medium: #025c5c;
        --green-light: #65c1b2;

        --blue-dark: #3f345f;
        --blue-medium: #3139B6;
        --blue-light: #7981f5;

        --purple-dark: #4B4461;
        --purple-first: #7765AB;
        --purple-second: #977CE5;

        --white: #F6F9FB;
        --black: #32424E;
        --background: #ecf1f8;
        --gray: #747474;
        --grayless: #DDDDDD;
    }
`;
